(() => {
 'use strict';
 const $ = s => document.querySelector(s);
  const dublinDateParts = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Dublin', year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
  });
  function dublinParts(date) {
    return Object.fromEntries(dublinDateParts.formatToParts(date)
      .filter(part => part.type !== 'literal').map(part => [part.type, Number(part.value)]));
  }
  // Convert the desired Dublin wall time using the offset at the target date.
  // This also handles weeks that cross a daylight saving change.
  function dublinInstant(wallTime) {
    let instant = wallTime;
    for (let i = 0; i < 3; i++) {
      const p = dublinParts(new Date(instant));
      const rendered = Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second);
      instant += wallTime - rendered;
    }
    return instant;
  }
  function nextFridayNight(now) {
    const p = dublinParts(now);
    const today = new Date(Date.UTC(p.year, p.month - 1, p.day));
    let days = (5 - today.getUTCDay() + 7) % 7;
    let wallTime = Date.UTC(p.year, p.month - 1, p.day + days, 19, 45);
    let target = dublinInstant(wallTime);
    if (target <= now.getTime()) target = dublinInstant(wallTime + 7 * 86400000);
    return target;
  }
  let fridayTarget = 0;
  function updateFridayCountdown() {
    const clock = $('#friday-countdown');
    if (!clock) return;
    const now = new Date();
    if (fridayTarget <= now.getTime()) {
      fridayTarget = nextFridayNight(now);
      clock.dateTime = new Date(fridayTarget).toISOString();
    }
    let seconds = Math.max(0, Math.ceil((fridayTarget - now.getTime()) / 1000));
    const days = Math.floor(seconds / 86400); seconds %= 86400;
    const hours = Math.floor(seconds / 3600); seconds %= 3600;
    const minutes = Math.floor(seconds / 60); seconds %= 60;
    const two = n => String(n).padStart(2, '0');
    clock.textContent = (days ? days + 'd ' : '') + hours + 'h ' + two(minutes) + 'm ' + two(seconds) + 's';
    clock.setAttribute('aria-label', 'Until Friday at 19:45 in Dublin: ' + days + ' days, ' + hours + ' hours, ' + minutes + ' minutes and ' + seconds + ' seconds');
  }
  let clockTimer = null;
  function syncClock() {
    clearInterval(clockTimer); clockTimer = null;
    const clock = $('#friday-countdown');
    if (!clock) return;
    if (!window.SevenFortyFive.motion.enabled()) {
      fridayTarget = nextFridayNight(new Date());
      clock.dateTime = new Date(fridayTarget).toISOString();
      clock.textContent = 'Friday, 7:45pm';
      clock.setAttribute('aria-label','Next Friday at 7:45pm');
      return;
    }
    updateFridayCountdown();
    if (!document.hidden) clockTimer = setInterval(updateFridayCountdown, 1000);
  }
  syncClock();
  document.addEventListener('745:motionchange', syncClock);
  document.addEventListener('visibilitychange', syncClock);
  const motionQuery = matchMedia('(prefers-reduced-motion: reduce)');
  let layoutFrame = null;
  function refreshLayout() {
    const opening = $('.hero');
    if (opening) opening.classList.toggle('is-tall',opening.offsetHeight > innerHeight + 2);
    for (const element of [$('.wordmark'), $('.site-header nav')]) {
      const r = element.getBoundingClientRect();
      const x = Math.min(innerWidth - 1, Math.max(0,r.left + r.width / 2));
      const y = Math.max(0,r.top + r.height / 2);
      const beneath = document.elementsFromPoint(x,y).find(el => !el.closest('#site-header') && !el.closest('#cursor') && el.closest('main,footer'));
      element.classList.toggle('on-dark',Boolean(beneath && beneath.closest('[data-tone="dark"]')));
    }
    const info = $('.product-info');
    if (info) {
      info.style.setProperty('--panel-height', info.offsetHeight + 'px');
      info.classList.toggle('needs-scroll',innerWidth > 760 && info.offsetHeight > innerHeight - 150);
    }
    layoutFrame = null;
  }
  function scheduleLayout() {
    if (layoutFrame === null) layoutFrame = requestAnimationFrame(refreshLayout);
  }
  addEventListener('scroll',scheduleLayout,{passive:true});
  document.addEventListener('745:motion',scheduleLayout);
  addEventListener('resize',scheduleLayout);
  motionQuery.addEventListener('change',scheduleLayout);
  if ($('.product-info')) new ResizeObserver(scheduleLayout).observe($('.product-info'));
  if ($('.hero')) new ResizeObserver(scheduleLayout).observe($('.hero'));
  refreshLayout();
  document.fonts.ready.then(scheduleLayout);
  if (location.hash) {
    requestAnimationFrame(() => {
      const target = document.getElementById(location.hash.slice(1));
      if (target) target.scrollIntoView({behavior:'instant',block:'start'});
    });
  }
  if (matchMedia('(hover: hover) and (pointer: fine)').matches) {
    const cursor = $('#cursor');
    let tx=0,ty=0,cx=0,cy=0,active=false,frame=null;
    function updateHover() {
      const element = document.elementFromPoint(tx,ty);
      cursor.classList.toggle('is-hover',Boolean(element && element.closest('a,button,summary')));
    }
    function animateCursor() {
      const amount = window.SevenFortyFive.motion.enabled() ? .55 : 1;
      cx += (tx - cx) * amount;
      cy += (ty - cy) * amount;
      const ratio = devicePixelRatio || 1;
      cursor.style.transform = 'translate(' + Math.round(cx * ratio) / ratio + 'px,' + Math.round(cy * ratio) / ratio + 'px)';
      if (active && (Math.abs(tx-cx) + Math.abs(ty-cy) > .03)) frame = requestAnimationFrame(animateCursor);
      else frame = null;
    }
    document.addEventListener('pointermove', e => {
      if (e.pointerType !== 'mouse') return;
      tx=e.clientX;ty=e.clientY;
      if (!active) {active=true;cx=tx;cy=ty;}
      document.body.classList.add('cursor-ready');
      updateHover();
      if (frame === null) frame=requestAnimationFrame(animateCursor);
    },{passive:true});
    document.addEventListener('keydown',e=>{if(e.key==='Tab') document.body.classList.remove('cursor-ready');});
    function stopCursor() {
      active=false;
      if(frame !== null) cancelAnimationFrame(frame);
      frame=null;
      document.body.classList.remove('cursor-ready');
    }
    document.documentElement.addEventListener('pointerleave',stopCursor);
    addEventListener('blur',stopCursor);
    addEventListener('scroll',()=>{if(active)updateHover();},{passive:true});
  }

})();
